/* src/app/modules/display/components/menus/product-menu/building-blocks/menu-header/menu-header-logo-desc-image/menu-header-centered-logo-right-desc-and-image/menu-header-centered-logo-right-desc-and-image.component.scss */
/*# sourceMappingURL=menu-header-centered-logo-right-desc-and-image.component.css.map */
